import { IOrderDetails } from '@/models/orders.model';
import { TOrderDetailsFormValues, OrderDetailsFormFieldsNames } from '../helpers';

export const getProductsFormValues = (order: IOrderDetails | null): TOrderDetailsFormValues | undefined => {
  const result: TOrderDetailsFormValues = {
    [OrderDetailsFormFieldsNames.PRODUCTS]: {},
    [OrderDetailsFormFieldsNames.COMMENTS]: {},
  };
  order?.sub_orders.forEach((sub) => {
    result[OrderDetailsFormFieldsNames.COMMENTS][sub.id] = '';
    sub.products.reduce((acc, item) => {
      acc[OrderDetailsFormFieldsNames.PRODUCTS][item.id] = item.quantity;
      return acc;
    }, result);
  });

  if (order) {
    return result;
  }
};
